<template lang="pug">
div
  .md-headline Partners
  div(v-if="!isEnabled")
    p.partner-row-disabled This feature is not enabled for this distribution's package.
  div(v-else)
    p.partner-row-hint Configure up to 6 partner feeds shown in the partner row.
    div(v-for="(partnerId, index) in localPartners" :key="index").partner-row-item
      md-input-container.partner-select-container(:class="{ 'md-input-invalid': formSubmitted && !localPartners[index] }")
        label Partner {{ index + 1 }}
        md-select(
          :value="localPartners[index]"
          :name="`partner-${index}`"
          @input="onSelectPartner(index, $event)"
        )
          md-option(
            v-for="dist in optionsFor(index)"
            :key="dist._id"
            :value="dist._id"
          ) {{ dist.name }}
        span.md-error(v-show='formSubmitted && !localPartners[index]') This field is required
      md-button.md-icon-button.md-warn(@click="removePartner(index)" title="Remove")
        md-icon(md-iconset="fa fa-trash-alt")
    md-button.md-raised(
      v-if="localPartners.length < 6"
      @click="addPartner"
    )
      md-icon(md-iconset="fa fa-plus")
      | Add Partner
    p.partner-row-count {{ localPartners.length }} / 6 partners configured
</template>

<script>
import { mapState } from 'vuex';
import distributionService from '../../../services/distributionService';

export default {
  props: {
    partners: {
      type: Array,
      default: () => []
    },
    currentDistributionId: {
      type: String,
      default: null
    },
    isEnabled: {
      type: Boolean,
      default: false
    },
    formSubmitted: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localPartners: [],
      allDistributions: [],
    };
  },

  computed: {
    ...mapState({
      siteuser: (state) => state.user.siteuser,
    }),
    isSuperAdmin() {
      return !!(
        this.siteuser &&
        this.siteuser.authorization &&
        this.siteuser.authorization.roles &&
        this.siteuser.authorization.roles.includes('SuperAdmin')
      );
    },
    isValid() {
      return this.localPartners.every(Boolean);
    },
  },

  watch: {
    partners: {
      immediate: true,
      handler(newVal) {
        this.localPartners = Array.isArray(newVal)
          ? newVal.map((p) => (p && p._id ? p._id : p)).filter(Boolean)
          : [];
      }
    },
    isValid: {
      immediate: true,
      handler(val) {
        this.$emit('partners-valid', val);
      }
    },
    isEnabled: {
      immediate: true,
      handler(val) {
        if (val) this.loadDistributions();
      }
    },
  },

  methods: {
    async loadDistributions() {
      try {
        const params = { sortBy: 'name', sortOrder: 'asc' };
        const response = this.isSuperAdmin
          ? await distributionService.getAll(params)
          : await distributionService.getList({ ...params, limit: 200, offset: 0 });
        this.allDistributions = response.data.distributions || [];
      } catch (error) {
        console.error('PartnerRowForm: failed to load distributions', error);
        this.allDistributions = [];
      }
    },

    optionsFor(index) {
      const excluded = new Set(
        this.localPartners.filter((id, i) => i !== index && id)
      );
      if (this.currentDistributionId) excluded.add(this.currentDistributionId);
      return this.allDistributions.filter((d) => !excluded.has(d._id));
    },

    addPartner() {
      if (this.localPartners.length < 6) {
        this.localPartners.push('');
      }
    },

    removePartner(index) {
      this.localPartners.splice(index, 1);
      this.emitChange();
    },

    onSelectPartner(index, value) {
      this.$set(this.localPartners, index, value);
      this.emitChange();
    },

    emitChange() {
      this.$emit('update:partners', this.localPartners.filter(Boolean));
    },
  },
};
</script>

<style lang="scss" scoped>
.partner-row-hint {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.md-raised {
  color: #fff !important;
}

.partner-row-disabled {
  font-size: 14px;
  color: #aaa;
  font-style: italic;
}

.partner-row-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;

  .partner-select-container {
    flex: 1;
  }
}

.partner-row-count {
  font-size: 12px;
  color: #888;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/PartnerRowForm.vue